import { render } from "./LbrxLoaderSpinner.vue?vue&type=template&id=2749d1ec"
import script from "./LbrxLoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LbrxLoaderSpinner.vue?vue&type=script&lang=js"

import "./LbrxLoaderSpinner.vue?vue&type=style&index=0&id=2749d1ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__